import { createTheme } from '@mui/material/styles'
import { filledInputClasses } from '@mui/material';

// #ced3dc
// #f3ca40
// #577590
// #7a542e


//#866a25
const blue = "#2d507b"; // #2d507b
const blueLight = "#4a7dbb"; //#4a7dbb
const blueDark = "#223c5c"; // #223c5c

//#3e6da6
const orange = "#f3ca40";
const orangeLight = "#f3ca40";
const orangeDark = "#cfae42"; // #cfae42

const red = "#d32f2f";
const redLight = "#ef5350";
const redDark = "#c62828";

const green = "#05aa05";
const greenLight = "#17d133";
const greenDark = "#2e7d32";

const grey = "#9f9f9f";

export const ThemeFormada = createTheme({
    typography: {
        "fontFamily": `Montserrat, Sans-Serif`,
        "fontSize": 16
    },
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                    color: "#000000",
                    backgroundColor: orange,
                    width: "auto",
                    boxShadow: "1px 1px 5px grey",
                    paddingLeft: "25px",
                    paddingRight: "25px",
                    borderRadius: "15px",
                    "&:disabled": {
                        color: '#ffffff',
                        backgroundColor: grey,
                        boxShadow: "1px 1px 5px grey"
                    },
                    ":hover": {
                        backgroundColor: orangeDark,
                        boxShadow: "1px 1px 5px grey"
                    }
                },
            },
        },
        MuiIconButton: {
            styleOverrides: {
                root: {
                    padding: "12px"
                },
            },
        },
        MuiFilledInput: {
            styleOverrides: {
                root: {
                    backgroundColor: "white",
                    ":hover": {
                        backgroundColor: "white",
                    },
                    [`&.${filledInputClasses.focused}`]: {
                        backgroundColor: "white"
                    }
                },
                input: {
                    ":autofill": {
                        borderRadius: "inherit"
                    },
                }
            },
        }
    },
    palette: {
        background: {
            default: blue
        },
        primary: {
            light: blue,
            main: blue,
            dark: blueDark,
            contrastText: "#ffffff"
        },
        secondary: {
            light: orangeLight,
            main: orange,
            dark: orangeDark,
            contrastText: "#000000"
        },
        success: {
            light: greenLight,
            main: green,
            dark: greenDark,
            contrastText: "#ffffff"
        },
        error: {
            light: redLight,
            main: red,
            dark: redDark,
            contrastText: "#ffffff"
        },
        rootContainer: {
            color: "#ffffff",
            background: blue
        },
        button: {
            primary: {
                color: "#000000",
                background: orange,
                backgroundHover: orangeDark
            },
            apple: {
                color: "#000000",
                background: "#ffffff",
                backgroundHover: "#eeeeee"
            },
            confirm: {
                color: "#ffffff",
                background: green,
                backgroundHover: greenDark
            },
            cancel: {
                color: "#ffffff",
                background: red,
                backgroundHover: redDark
            }
        },
        menu: {
            color: "#ffffff",
            background: blueLight
        },
        progress: {
            circular: {
                primary: blue,
                secondary: orange
            },
            linear: {
                primary: orange,
                secondary: "#ffd7a3"
            }
        },
        infoIcon: blue,
        dialog: {
            title: {
                color: "#ffffff",
                background: blue
            },
            primaryButton: {
                color: "#000000",
                background: orange,
                backgroundHover: orangeDark,
                backgroundDisabled: grey
            }
        },
        appBar: {
            color: "#ffffff",
            background: blue
        },
        textLink: blue,
        card: {
            primary: {
                color: "#ffffff",
                background: blue
            },
            secondary: {
                color: "#000000",
                background: orange
            }
        }
    }
});